<template>
    <form class="form" @submit.prevent="insertTable">
        <label>
            <div>Rows</div>
            <input v-model="rows" min="2" style="width: 60px" type="number">
        </label>
        <label>
            <div>Columns</div>
            <input v-model="cols" min="2" style="width: 60px" type="number">
        </label>

        <button type="submit">Insert</button>
    </form>
</template>

<script>

export default {
    title: 'table',
    description: 'Insert Table',
    icon: 'Table',

    data() {
        return {
            rows: 2,
            cols: 2,
        };
    },
    methods: {
        insertTable() {
            const rows = (
                '<tr>' + '<td></td>'.repeat(this.cols) + '</tr>'
            ).repeat(this.rows);

            this.$emit('exec', 'insertHTML', `<table><tbody>${ rows }</tbody></table>`);
            this.$parent.closeDashboard();
        },
    },
};

</script>

<style lang="scss" scoped>
.form {
    display: flex;
    align-content: flex-end;

    label {
        margin-right: 1rem;
    }
}
</style>
